import React, { useEffect, useMemo, useState } from 'react';
import { Box, Button, Chip, CircularProgress, Container, IconButton, Stack, TextField, Toolbar, Tooltip, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { listVenues, runScraper } from '../../../hooks/scraperHooks';
import TopClicked from './TopClicked';

export default function ScraperControl(){
const [rows, setRows] = useState([]);
const [loading, setLoading] = useState(true);
const [filter, setFilter] = useState('');


async function load(){
setLoading(true);
const { venues } = await listVenues(1000);
setRows(venues || []);
setLoading(false);
}
useEffect(()=>{ load(); },[]);


const filtered = useMemo(()=>{
const f = (filter||'').toLowerCase();
return rows.filter(r => !f || r.venue_name?.toLowerCase().includes(f) || r.slug?.toLowerCase().includes(f) || r.venue_city?.toLowerCase().includes(f));
}, [rows, filter]);


function fmt(ts) {
  if (!ts) return '';
  if (ts.toDate) return ts.toDate().toLocaleString();        // Firestore Timestamp object
  if (ts._seconds) return new Date(ts._seconds * 1000).toLocaleString(); // JSON form
  const d = new Date(ts);                                     // ISO/string fallback
  return isNaN(d) ? '' : d.toLocaleString();
}

return (
<Container maxWidth="xl" sx={{ py: 2 }}>
<Toolbar disableGutters sx={{ mb: 1 }}>
<Typography variant="h5" sx={{ flex: 1 }}>Scraper Control Center</Typography>
<Stack direction="row" spacing={1}>
<TextField size="small" placeholder="Filter by name / slug / city" value={filter} onChange={e=>setFilter(e.target.value)} />
<Tooltip title="Refresh"><span>
<IconButton onClick={load} disabled={loading}><RefreshIcon/></IconButton>
</span></Tooltip>
</Stack>
</Toolbar>

<TopClicked hours={6} limit={10} />

{loading ? (
<Stack alignItems="center" sx={{ py: 6 }}><CircularProgress/></Stack>
) : (
<TableContainer component={Paper}>
<Table size="small">
<TableHead>
<TableRow>
<TableCell>Venue</TableCell>
<TableCell>Slug</TableCell>
<TableCell>City</TableCell>
<TableCell align="right">Future</TableCell>
<TableCell align="right">Pop</TableCell>
<TableCell>Last Event</TableCell>
<TableCell>Last Scrape</TableCell>
<TableCell>Needs?</TableCell>
<TableCell>Actions</TableCell>
</TableRow>
</TableHead>
<TableBody>
{filtered.map((r)=>{
const need = (r.futureEventCount||0)===0 || !r.lastScrapedAt;
return (
<TableRow key={r.id}>
<TableCell>{r.venue_name}</TableCell>
<TableCell>{r.slug}</TableCell>
<TableCell>{r.venue_city}</TableCell>
<TableCell align="right">{r.futureEventCount||0}</TableCell>
<TableCell align="right">{(r.popularityScore||0).toFixed(3)}</TableCell>
<TableCell>{fmt(r.lastEventDate)}</TableCell>
<TableCell>{fmt(r.lastScrapedAt)}</TableCell>
<TableCell>
<Chip size="small" label={need? 'Yes':'No'} color={need? 'warning':'success'} />
</TableCell>
<TableCell>
<Stack direction="row" spacing={1}>
<Button size="small" variant="contained" startIcon={<PlayArrowIcon/>} onClick={()=>runScraper(r.slug)}>Run</Button>
<Tooltip title="View on site">
<IconButton onClick={()=>window.open(`https://webtunes.com/venues/${r.slug}`, '_blank')}><OpenInNewIcon/></IconButton>
</Tooltip>
</Stack>
</TableCell>
</TableRow>
);
})}
</TableBody>
</Table>
</TableContainer>
)}
</Container>
);
}